export const links = {
  geofence: {
    positionLevelGeofenceHelp:
      "https://help.bluecrewjobs.com/en/articles/6584904-position-level-geofence-controls",
  },
};
